exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".binding-lab-left{width:49%}.binding-lab-center,.binding-lab-left{text-align:center;font-size:15px;font-weight:700;float:left}.binding-lab-center{width:50px;margin-left:10px}.binding-lab-right{width:calc(50% - 70px);margin-left:10px;text-align:center;font-size:15px;font-weight:700;float:right}.binding-lab-query{width:100%;height:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/specialDictionary/laboratoryCategories/bindingLaboratoryCategories.vue
// module id = v4IV
// module chunks = 0